<template>
  <d-card class="">
    <d-collapse
      id="accordion2"
      accordion="my-accordion">
      <d-card-body style="padding: 1rem;">
        <div class="p-3 mt-3 border rounded">
          <table class="table mt-0 mb-0">
            <thead class="bg-light">
              <tr>
                <th
                  scope="col"
                  class="border-0">Produkt</th>
                <th
                  scope="col"
                  class="border-0 text-right">Ilość</th>
                <th
                  scope="col"
                  class="border-0 text-right">Waga</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, productIndex) in products"
                :key="'product-' + productIndex">
                <td class="">{{ product.product_name }}</td>
                <td class="text-right">{{ product.quantity }} szt.</td>
                <td class="text-right">{{ product.weight }} kg</td>
              </tr>
            </tbody>
          </table>
        </div>
      </d-card-body>
    </d-collapse>
  </d-card>
</template>

<script>
export default {
  name: 'orders-collapse-products',
  props: {
    products: {
      type: [Object, Array],
      required: true
    },
  }
};
</script>
